// using module.exports here so gatsby-config can read it
module.exports = {
  // TODO: uncomment next line and enter your own public API key
  //builderAPIKey: process.env.BUILDER_API_KEY
  builderAPIKey: "7e5329b9c0524b70a2d901aeda426cda"
};
